import React from 'react';
import { FiMapPin, FiStar, FiUser } from 'react-icons/fi';
import { openExternalUrl } from '../../../services/webviewService';

export interface VendorCardProps {
  vendor_id: number;
  link: string;
  photo?: string;
  name?: string;
  city?: string;
  province?: string;
  rating?: number;
  reviews?: number;
  description?: string;
}

export const VendorCard: React.FC<VendorCardProps> = ({
  link,
  photo,
  name,
  city,
  province,
  rating,
  reviews,
  description,
}) => (
  <a
    href={link}
    onClick={(event) => {
      event.preventDefault();
      openExternalUrl(link);
    }}
    className="group block h-full rounded-ds-16 border border-ds-100 bg-ds-white p-4 transition-[border-color,box-shadow,transform] hover:-translate-y-0.5 hover:border-ds-200 hover:shadow-ds-2"
  >
    <div className="flex items-center gap-3">
      {photo ? (
        <img src={photo} alt={name || 'غرفه'} className="h-[52px] w-[52px] shrink-0 rounded-full border border-ds-100 object-cover" />
      ) : (
        <span className="grid h-[52px] w-[52px] shrink-0 place-items-center rounded-full border border-ds-100 bg-[#e8dfd4] text-[#704832]"><FiUser size={20} /></span>
      )}
      <div className="min-w-0 flex-1">
        <h3 className="truncate text-sm font-bold text-ds-ink group-hover:text-ds-primary-strong">{name || 'غرفه باسلام'}</h3>
        {(city || province) && (
          <p className="mt-1 flex items-center gap-1 truncate text-[11px] text-ds-500">
            <FiMapPin size={12} />{[province, city].filter(Boolean).join('، ')}
          </p>
        )}
      </div>
    </div>

    {(rating !== undefined || reviews !== undefined) && (
      <div className="mt-3 grid grid-cols-2 border-t border-ds-100 pt-3 text-center text-[10px] text-ds-500">
        <span>
          <b className="mb-1 flex items-center justify-center gap-1 text-xs text-ds-800"><FiStar className="fill-[#ffa41c] text-[#ffa41c]" size={12} />{rating?.toLocaleString('fa-IR') || '—'}</b>
          امتیاز غرفه
        </span>
        <span className="border-r border-ds-100">
          <b className="mb-1 block text-xs text-ds-800">{reviews?.toLocaleString('fa-IR') || '۰'}</b>
          تجربه خرید
        </span>
      </div>
    )}

    {description && <p className="line-clamp-2-safe mt-3 text-[11px] leading-[1.9] text-ds-600">{description}</p>}
  </a>
);
